// latest: hans 2017-4-6 6:35 PM
import { indexOf, map } from 'lodash'
import { Post } from 'common'
import uMessage from 'components/message'
/* global  __ */
const opt = {
  '1': ['view'],
  '2': [],
  '3': ['view'],
  '4': ['view'],
  '5': ['view'],
  '6': ['view']
}
// 根据状态显示不同的操作
let handlers = {
  view: {
    text: '查看',
    handler (obj) {
      let type = obj.row.value.templateType
      let url = ''
      if (type > 3) {
        url = '../tplevaluateedit/index.' + __('locale') + '.html?editable=false&id=' +
        obj.row.value.templateId + '&type=' + obj.row.value.templateType
        window.open(url)
      } else if (type == 3) {
        url = '../tplcertificationedit/index.' + __('locale') + '.html?editable=false&id=' +
        obj.row.value.templateId + '&type=' + obj.row.value.templateType
        window.open(url)
      } else if (type == 1) {
        url = '../qualifytpl/index.' + __('locale') + '.html?id=' +
        obj.row.value.templateId + '&edit=false'
        window.open(url)
      } else {
        uMessage('产品试验为通用模板,无法查看详情')
      }
    }
  },
  delete: {
    text: '删除',
    async handler (obj, callback) {
      window.u.confirmDialog({
        // 您确定要删除所选数据吗？
        id: 'confirmDialog',
        msg: '<span><i class="uf uf-exc-c-2 uf-delete"></i>是否删除当前模板吗？</span>',
        title: '确认删除',
        onOk: function () {
          var asyncRead = async function () {
            let idsArray = []
            idsArray.push(obj.row.value.id)
            let result = await Post('/cpu-supplymgr/templateAllot/deleteByIds', {ids: idsArray})
            if (result.status === 1) {
              uMessage('success', result.msg)
              console.log(callback)
              callback.reload()
            } else {
              uMessage('fail', result.msg)
            }
          }
          asyncRead()
        },
        onCancel: function () {}
      })
    }
  }
}

export default function createOptItem (callback) {
  return map(handlers, function (handlerObj, key) {
    var hide = handlerObj.hide || function () {
      return false
    }
    // 这里可以统一在handlers里定义
    handlerObj.hidden = function (obj) {
      var hasOpt = opt[obj.row.value.templateType]
      return indexOf(hasOpt, key) === -1 || hide(obj.row.value)
    }
    handlerObj.callback = callback
    return handlerObj
  })
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/tplHistorySelect/opt.js